import("../../../css/bem/_quick-wishlist.scss");
import { addToWishlist, removeFromWishlist, getCurrentWishlistData, getWishlistCount } from "./wishlist-services";
import { wishlistGetProductId } from "../associated-product/associated-product";
import { displayToast } from "../toastify/toastify";
import { ReferenceElement } from "tippy.js";

const wishlistSelector = ".js-wishlist-icon";
const wishlistHeaderCount = ".js-wishlist-count";
const toggleActiveClass = (elm: HTMLElement) => elm.classList.toggle("is-active");
const getActiveClass = (elm: HTMLElement) => elm.classList.contains("is-active");
const modifyContent = (elm: HTMLElement, html) => (elm.innerHTML = html);
const setDataAttribute = (elm: HTMLElement, toggle: boolean) => (elm.setAttribute("data-tippy-content" , 
getDataState(elm, toggle)));
const getDataState = (elm: HTMLElement, toggle: boolean) => elm.getAttribute(toggle ? "data-tippy-deactive" : "data-tippy-active")

export const toggleIconState = (id) => {
	(document.querySelectorAll(wishlistSelector) as NodeListOf<HTMLElement>).forEach((icon) => {
		if (Number(wishlistGetProductId(icon)) === id) {
			const instance = (<ReferenceElement>icon)._tippy
			toggleActiveClass(icon);
			setDataAttribute(icon, getActiveClass(icon));
			instance.setContent(getDataState(icon, getActiveClass(icon)));
		}
	});
};

const handleWishlistClick = async (elm, productid) => {
	var isRemove = elm.classList.contains("is-active"),
		request = isRemove ? await removeFromWishlist(productid) : await addToWishlist(productid),
		message = request.success ? (isRemove ? "Removed from wishlist" : "Added to wishlist") : "An Unexpected Error Occurred";

	displayToast(message, {
		className: "toastify-center rounded px-lg-5 " + (request.success ? "swatch-dark" : "swatch-danger"),
		duration: 1500,
	});

	wishlistPageCheck(isRemove);

	if (request.success) {
		updateWishlistCount({ cacheBuster: true });
		toggleIconState(productid);
	}
};

export const updateWishlistCount = async ({ count = -1, cacheBuster = false }) => {
	if (count < 0) count = await getWishlistCount({ cacheBuster });
	(document.querySelectorAll(wishlistHeaderCount) as NodeListOf<HTMLElement>).forEach((item) => {
		modifyContent(item, count ?? 0);
	});
};

export const setUpWishlistBtnEventListeners = (context: HTMLElement | Document = document, wishlistFetchOptions?: { cacheBuster: boolean }) => {
	const allElms = context.querySelectorAll(wishlistSelector);

	getCurrentWishlistData(wishlistFetchOptions).then((wishlist) => {
		const wishlistIds = wishlist && wishlist[0] ? (wishlist as Array<any>).map((item) => item.productId) : [];

		allElms.forEach((elm) => {
			const productid = Number(wishlistGetProductId(elm));

			if (wishlistIds.includes(productid)) elm.classList.add("is-active");

			elm.addEventListener("click", () => {
				handleWishlistClick(elm, productid);
			});
		});
	});
};

const wishlistPageCheck = (isRemove: boolean) => {
	const isWishlist = document.querySelector("body.wishlist");
	const isAccount = document.querySelector("body.accountPage");
	if (isRemove && isWishlist)
		setTimeout(() => {
			location.reload();
		}, 100);
	if (isRemove && isAccount) {
		let url;
		if (window.location.href.indexOf("#wishlist") < 1) url = window.location.href += "#wishlist";
		setTimeout(() => {
			location.reload();
		}, 100);
	}
};
